import React from 'react'
import styled from 'styled-components'
import { BlueButton } from '../../buttons'
import { DownloadIcon } from '../../icons'

const Container = styled.div`
    display: inline-block;

    button {
        width: 100%;
    }
`

type Props = {
    className?: string
}

const ZoomMakerStarterButton = ({ className }: Props) => {
    const onClick = () => {
        window &&
            window.scroll({
                top: 920,
                behavior: 'smooth',
            })
    }

    return (
        <Container className={className}>
            <BlueButton onClick={onClick}>
                <DownloadIcon /> Choose Starter
            </BlueButton>
        </Container>
    )
}

export default ZoomMakerStarterButton
